import { render, staticRenderFns } from "./SectionSeparator.vue?vue&type=template&id=616e70c1&scoped=true&"
import script from "./SectionSeparator.vue?vue&type=script&lang=js&"
export * from "./SectionSeparator.vue?vue&type=script&lang=js&"
import style0 from "./SectionSeparator.vue?vue&type=style&index=0&id=616e70c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e70c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616e70c1')) {
      api.createRecord('616e70c1', component.options)
    } else {
      api.reload('616e70c1', component.options)
    }
    module.hot.accept("./SectionSeparator.vue?vue&type=template&id=616e70c1&scoped=true&", function () {
      api.rerender('616e70c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/SectionSeparator.vue"
export default component.exports